const MSMMBADetail = () => (
  <div className="container my-5">
    <h2>MBA - Healthcare Administration.</h2>
    <p>The MBA with a concentration in Health Care Administration includes courses focused on 
        the ever-changing environment of health care.  Students will demonstrate knowledge of a 
        variety of health care issues including health policy, insurance, demand for services, 
        and legal and ethical issues in today's global environment.</p>
  
  <h2>MS - Healthcare Administration Management.</h2>
  <p>The M.S. in Management with a concentration in Health Care Administration includes 
    courses centric to the ever-changing environment of health care.  Students will demonstrate 
    knowledge of a variety of health care issues including health policy, insurance, demand for services, 
    and legal and ethical issues in today's global environment..</p>
  </div>
);

export default MSMMBADetail;